<template>
    <div class="">
        <div class="campaign-image rounded-t-22 overflow-hidden">
            <div :style="{'background-image': `url('${serialModel.campaignImgUrl}')`}"></div>
        </div>
        <div>
            <div class="px-4 pt-4 font-medium text-12 text-a-black-484848">
                {{serialModel.agencyName}}
            </div>
            <div class="px-4 font-light text-12 text-a-black-484848">
                {{serialModel.campaignName}}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "SerialDetail",
    props: {
        serialModel: Object,
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        div {
            @include boxRatio(66.66%);
        }
    }
</style>
